import React from 'react';
import checkIsSingleEmailForm from 'components/Form/utils/checkIsSingleEmailForm';
import EmailSubscribeForm from 'components/Form/EmailSubscribeForm';
import MarketoForm from 'components/Form/MarketoForm/index';

const ContentfulInlineMarketingFormColumnWrapper = item => {
  const isSingleEmailForm = checkIsSingleEmailForm(item.marketoForm);

  return isSingleEmailForm ? (
    <EmailSubscribeForm dataPosition="Column" inlineMarketingForm={item} styles={item.styles} />
  ) : (
    <MarketoForm dataPosition="Column" inlineMarketingForm={item} />
  );
};

export default ContentfulInlineMarketingFormColumnWrapper;
